import { useEffect, useRef } from "react"

/**
 * Calls `clear` when the chosen `location` stops being one of `depots` (for example after a
 * date change makes it unavailable). Waits until `ready`, so a depot list still loading doesn't
 * wipe the field.
 */
export const useClearUnavailableLocation = (
  location: string,
  depots: { name: string }[],
  ready: boolean,
  clear: () => void,
) => {
  const clearRef = useRef(clear)
  clearRef.current = clear

  useEffect(() => {
    if (ready && location && !depots.some((depot) => depot.name === location)) clearRef.current()
  }, [ready, location, depots])
}
